import React, { useEffect } from 'react';

export default function LightboxModal({ images, activeIndex, onClose, onSelectIndex }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && activeIndex > 0) onSelectIndex(activeIndex - 1);
      if (e.key === 'ArrowRight' && activeIndex < images.length - 1) onSelectIndex(activeIndex + 1);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeIndex, images, onClose, onSelectIndex]);

  if (activeIndex === null || activeIndex === undefined || !images || !images[activeIndex]) return null;

  const currentImg = images[activeIndex];

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in"
      role="dialog"
      aria-modal="true"
      aria-label="Billedvisning"
    >
      {/* Close button */}
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-3 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-white"
        aria-label="Luk billedvisning"
      >
        <i className="fa-regular fa-xmark text-xl" aria-hidden="true"></i>
      </button>

      {/* Prev button */}
      {activeIndex > 0 && (
        <button
          type="button"
          onClick={() => onSelectIndex(activeIndex - 1)}
          className="absolute left-4 z-10 p-3 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Forrige billede"
        >
          <i className="fa-regular fa-chevron-left text-xl" aria-hidden="true"></i>
        </button>
      )}

      {/* Next button */}
      {activeIndex < images.length - 1 && (
        <button
          type="button"
          onClick={() => onSelectIndex(activeIndex + 1)}
          className="absolute right-4 z-10 p-3 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Næste billede"
        >
          <i className="fa-regular fa-chevron-right text-xl" aria-hidden="true"></i>
        </button>
      )}

      {/* Image container */}
      <div className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
        <img
          src={currentImg}
          alt={`Billede ${activeIndex + 1} af ${images.length}`}
          className="max-w-full max-h-[75vh] object-contain rounded-lg shadow-2xl"
        />
        <p className="mt-4 text-xs font-medium text-slate-300">
          Billede {activeIndex + 1} af {images.length}
        </p>
      </div>
    </div>
  );
}
